import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=8710c5e0&lang=pug&"
import script from "./SelectField.vue?vue&type=script&lang=js&"
export * from "./SelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8710c5e0')) {
      api.createRecord('8710c5e0', component.options)
    } else {
      api.reload('8710c5e0', component.options)
    }
    module.hot.accept("./SelectField.vue?vue&type=template&id=8710c5e0&lang=pug&", function () {
      api.rerender('8710c5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/SelectField.vue"
export default component.exports